import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import $ from 'jquery';
import * as _ from 'lodash';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';




@Component({
  components: {

  },
})
export default class ProductSelector extends Vue {
  private _configuratorService: ConfiguratorService = undefined;



  @Inject()
  private _container: ComponentContainer;


  public products: ProductDefinition[] = [];

  @Prop()
  public family: any;

  public selectedProduct:ProductDefinition = null;






  created() {
    this.selectedProduct = Store.state.product;
    this.products = Store.getProductsByFamilyId(Store.state.family.id) as any;
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

    if (Store.state.product.initialCommands && Store.state.product.initialCommands.camera)
    {
      this._configuratorService.Client.lookat(Store.state.product.initialCommands.camera.position, Store.state.product.initialCommands.camera.target, 1);
    }

  }

  productChanged(product: ProductDefinition) {
    if (Store.state.product.id !== product.id) {
      this.selectedProduct = product;
      Store.state.product = product;
      Store.state.selection = null;
      document.title = product.name;
    }
    if (Store.state.product.initialCommands && Store.state.product.initialCommands.camera)
    {
      this._configuratorService.Client.lookat(Store.state.product.initialCommands.camera.position, Store.state.product.initialCommands.camera.target, 1);
    }
    this.$emit('productSelected',this.selectedProduct);
  }

  mounted() {


  }

}



// WEBPACK FOOTER //
// ./src/components/productSelector/ProductSelector.ts